import { useEffect, useState, useCallback } from "react";
import * as Scrivito from "scrivito";
import moment from "moment";
import FetchMoreButton from "^/Components/FetchMoreButton";
import { getNewsCategories } from "^/utils/getNewsCategories";
import basicNewsQuery from "^/utils/basicNewsQuery";
import Story from "^/Components/StoriesPreview/Story";
import EventsBlock from "./EventsBlock";
import CategoriesBlock from "./CategoriesBlock";

Scrivito.provideComponent("GlobalNewsWidget", ({ widget }) => {
  const page = widget.obj();
  const siteId = page.siteId();
  const lang = page.language();
  const pageLength = widget.get("newsCountPerPage") || 30;
  const [category, setCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [items, setItems] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [searchTotal, setSearchTotal] = useState(0);
  const currentHour = moment().startOf("day").toDate();
  const filter = widget.get("categoryFilter") || [];

  const fetchMoreData = useCallback(() => {
    setFetching(true);
    let allQuery = basicNewsQuery(siteId, currentHour, pageNumber * pageLength);
    allQuery = allQuery.and("showInGlobalNews", "equals", true);
    if (category !== "") {
      allQuery = allQuery.andFullTextOf(
        "customizableCategories",
        "contains",
        category
      );
    }
    allQuery = allQuery.order("publishFromDate", "desc");
    Scrivito.load(() => {
      const response = allQuery.take(pageLength);
      const count = allQuery.count();
      return {
        searchCount: count,
        searchItems: response,
      };
    }).then((data) => {
      const { searchItems, searchCount } = data;
      setItems([...items, ...searchItems]);
      setPageNumber(pageNumber + 1);
      setSearchTotal(searchCount);
      setFetching(false);
    });
  }, [category, currentHour, items, pageLength, pageNumber, siteId]);

  useEffect(() => {
    fetchMoreData();
  }, [category, fetchMoreData]);

  useEffect(() => {
    if (categories.length === 0) {
      getNewsCategories().then((cats) => setCategories(cats));
    }
  });

  useEffect(() => {
    const currentPageParams = Scrivito.currentPageParams();
    if (category !== currentPageParams.category) {
      if (
        categories
          .map((item) => item.key)
          .indexOf(currentPageParams.category) !== -1
      ) {
        setPageNumber(0);
        setItems([]);
        setCategory(currentPageParams.category);
      }
    }
  }, [categories, category]);

  const handleCategoryChange = (cat) => {
    setItems([]);
    setPageNumber(0);
    setCategory(cat);
    Scrivito.navigateTo(page, {
      params: { category: cat },
      hash: "categories",
    });
  };

  return (
    <Scrivito.WidgetTag className="container pt-4 pb-4">
      <div className="row">
        <div className="col-sm-8">
          <h3>News</h3>
          <CategoriesBlock
            categories={categories}
            filter={filter}
            language={lang}
            handleCategoryChange={handleCategoryChange}
            category={category}
          />
          {items.map((story) => (
            <Story story={story} key={story.id()} pageType={"NewsPage"} />
          ))}
          <FetchMoreButton
            show={searchTotal > items.length}
            fetching={fetching}
            onClick={fetchMoreData}
            language={lang}
          />
        </div>
        <EventsBlock widget={widget} siteId={siteId} language={lang} />
      </div>
    </Scrivito.WidgetTag>
  );
});
